module.exports = __webpack_public_path__ + "img/s1.a7aa11e0.png";